import axios from "axios";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const AUTH_BASE = "/auth/v1";
const KEYCLOCK_BASE = GATEWAY_BASE + AUTH_BASE;

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: KEYCLOCK_BASE,
});

export default axiosInstance;
